import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Divider,FormControlLabel,Radio,RadioGroup } from "@mui/material";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import FirstRadio from "./firstRadio";
import SecondRadio from "./secondRadio";
import ThirdRadio from "./thirdRadio";
import { useQuery } from "@tanstack/react-query";
import { fetchUserListBusinesses } from "@/api/user/home";

type JobQualificationsSecondTabProps = {
  setUploadedImages: Dispatch<SetStateAction<any>>;
  setSelectedOption: Dispatch<SetStateAction<any>>;
  selectedOption: any;
  setJob: any;
  job: any;
  setPrivateEmployee: any;
  setGovernmentEmployeeCountry: any;
  setFreelanceJob: any;
  setUploadImageJob: any;
  setUploadImageElseJob: any;
};
/**
 * JobQualificationsSecondTab
 *
 * تب دوم در فرآیند بررسی اطلاعات اعتباری کاربر.
 * شامل:
 * - انتخاب نوع شغل کاربر از میان گزینه‌های موجود.
 * - نمایش فرم‌ها و بخش‌های بارگذاری مدارک مرتبط با شغل انتخابی:
 *   - کارمند بخش دولتی (کشوری / لشکری): بارگذاری فیش حقوقی
 *   - کارمند بخش خصوصی: فرم اطلاعات شغلی + بارگذاری فیش حقوقی
 *   - صاحبین مشاغل آزاد: فرم اطلاعات شغلی + بارگذاری مدارک مرتبط
 *
 * ویژگی‌ها:
 * - دریافت لیست شغل‌ها با استفاده از useQuery و fetchUserListBusinesses.
 * - مدیریت انتخاب شغل با RadioGroup و state داخلی `test`.
 * - بارگذاری تصاویر مرتبط با شغل با استفاده از setUploadImageJob و setUploadImageElseJob.
 * - بروزرسانی شغل انتخابی در والد با setSelectedOption از طریق useEffect.
 *
 * @param {Object} props
 * @param {Dispatch<SetStateAction<any>>} props.setUploadedImages تابع مدیریت فایل‌های بارگذاری شده
 * @param {Dispatch<SetStateAction<any>>} props.setSelectedOption تابع مدیریت نوع شغل انتخابی
 * @param {any} props.selectedOption مقدار شغل انتخاب شده
 * @param {any} props.setJob تابع مدیریت state شغل خصوصی
 * @param {any} props.job اطلاعات شغل خصوصی
 * @param {any} props.setPrivateEmployee تابع مدیریت کارمند خصوصی (در صورت نیاز)
 * @param {any} props.setGovernmentEmployeeCountry تابع مدیریت کارمند دولتی
 * @param {any} props.setFreelanceJob تابع مدیریت اطلاعات مشاغل آزاد
 * @param {any} props.setUploadImageJob تابع بارگذاری تصویر فیش حقوقی
 * @param {any} props.setUploadImageElseJob تابع بارگذاری تصویر مدارک اضافی مشاغل آزاد
 *
 * @component
 * @returns JSX.Element
 */

const JobQualificationsSecondTab = (props: JobQualificationsSecondTabProps) => {
  const {
    setUploadedImages,
    setJob,
    job,
    setPrivateEmployee,
    setGovernmentEmployeeCountry,
    setFreelanceJob,
    setSelectedOption,
    selectedOption,
    setUploadImageJob,
    setUploadImageElseJob,
  } = props;

  const { data } = useQuery({
    queryKey: ["businesses-list"],
    queryFn: fetchUserListBusinesses,
  });

  const [test, setTest] = useState("test");

  useEffect(() => {
    setSelectedOption(test);
  }, [setSelectedOption, test]);

  return (
    <StackKit justifyContent={"space-between"} sx={{ width: "100%",paddingBottom: 2 }}>
      <StackKit justifyContent={"space-evenly"} alignItems={"start"}>
        <TypoGraphyKit variant="h6">
          لطفا شغل خود را از بین دسته بندی زیر انتخاب نمایید.
        </TypoGraphyKit>
        <RadioGroup value={test} sx={{ gap: 2, width: "100%" }} onChange={(e) => { setTest(e.target.value); setUploadImageJob(null);}}>
          <StackKit direction={"row"} justifyContent={"space-around"} sx={{ width: "100%", flexWrap: "wrap" }}>
            {data?.map((item) => {
              return (
                <StackKit sx={{ width: "40%" }}>
                  <FormControlLabel
                    value={item.title}
                    control={<Radio sx={{ color: "white" }} />}
                    label={
                      <TypoGraphyKit sx={{ color: "white" }}>
                        {item.title}
                      </TypoGraphyKit>
                    }
                  />
                </StackKit>
              );
            })}
          </StackKit>
        </RadioGroup>
        <Divider sx={{ width: "100%" }} />

        {test === "کارمند بخش دولتی (کشوری)" && (
          <FirstRadio setUploadImageJob={setUploadImageJob} />
        )}
        {test === "کارمند بخش دولتی (لشکری)" ? (
          <FirstRadio setUploadImageJob={setUploadImageJob} />
        ) : null}
        {test === "کارمند بخش خصوصی" ? (
          <SecondRadio setJob={setJob} job={job} setUploadImageJob={setUploadImageJob}/>
        ) : null}
        {test === "صاحبین مشاغل آزاد" ? (
          <ThirdRadio setFreelanceJob={setFreelanceJob} setUploadImageJob={setUploadImageJob} setUploadImageElseJob={setUploadImageElseJob}/>
        ) : null}
      </StackKit>
    </StackKit>
  );
};

export default JobQualificationsSecondTab;
